import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";

export class AceiteParceiro {
  propostaId: string;
  profissao: string;
  observacaoCredor: string;
  telefoneCredor: string;
  nomeComercial: string;
  nomeRepresentante: string;
  profissaoConjuge: string;
  emailCredor: string;
  idOfertaProposta: string;

  form: FormGroup;

  constructor(other?: any) {
    if (other) {
      this.propostaId = other.propostaId;
      this.profissao = other.profissao;
      this.observacaoCredor = other.observacaoCredor;
      this.telefoneCredor = other.telefoneCredor;
      this.nomeComercial = other.nomeComercial;
      this.nomeRepresentante = other.nomeRepresentante;
      this.profissaoConjuge = other.profissaoConjuge;
      this.emailCredor = other.emailCredor;
      this.idOfertaProposta = other.idOfertaProposta;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({
        propostaId: new FormControl(this.propostaId, [Validators.required]),
        profissao: new FormControl(this.profissao, [Validators.required]),
        observacaoCredor: new FormControl(this.observacaoCredor),
        telefoneCredor: new FormControl(this.telefoneCredor, [Validators.required]),
        nomeComercial: new FormControl(this.nomeComercial, [Validators.required]),
        nomeRepresentante: new FormControl(this.nomeRepresentante, [Validators.required]),
        profissaoConjuge: new FormControl(this.profissaoConjuge),
        emailCredor: new FormControl(this.emailCredor, [Validators.required, emailValidado()]),
        idOfertaProposta: new FormControl(this.idOfertaProposta),
      });
    }
    return this.form;
  }
}
export function emailValidado(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(control.value);
    return valid ? null : { invalidEmail: true };
  };
}
